export const container = (stagger = 0.2) => ({
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: stagger, // Intervalo entre cada card
    },
  },
});

export const dots = (duration = 0.5) => ({
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: duration },
  },
});

// Variantes para animación de contenedor principal (mobile/desktop)
export const pageContainerVariants = (esMobile) => ({
  hidden: esMobile 
    ? { opacity: 0, y: 100 }
    : { opacity: 0, x: 100 },
  visible: esMobile
    ? { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
    : { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeOut" } },
  exit: esMobile
    ? { opacity: 0, y: 100, transition: { duration: 0.3 } }
    : { opacity: 0, x: 100, transition: { duration: 0.3 } }
});